import React, { useContext } from 'react';
import { Row, Col, Card, Tooltip, Spin, Avatar } from 'antd';
import { Context } from '../context';
import { Appearer } from './Appearer';
import { LinkedinFilled, GlobalOutlined, InstagramOutlined, EllipsisOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';


const { Meta } = Card;

export function ProjectsGrid(props) {


  const { data } = props;

  return (
    <div>
      {data.length === 0 ? (
        <div className='_fcc _fv y _fgap2' style={{ minHeight: '80vh' }}>
          <Spin size="large" />
          <div >
            Loading
          </div>
        </div>
      ) : (
        <Row gutter={16}>
          {data.map((entry, index) => (
            <Col xs={12} sm={12} md={8} lg={6} key={entry._id}>
              <Appearer order={index}>
                <ProjectCard entry={entry} />
              </Appearer>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};



const ProjectCard = ({ entry }) => {

  const navigate = useNavigate();

  const { alumni, project } = useParams();
  const alumniHandle = alumni ? alumni.replace('@', '') : null;
  // Split credits into lines and limit to 3 lines for preview
  // const creditsLines = entry.alumniCredits;
  // const previewCredits = creditsLines.slice(0, 2);
  // const previewCredits = "";

  return (
    <>
      <div className="_fv _fgap0 _fc">
        <Card
          hoverable
          className='_pointer'
          bodyStyle={{ padding: "0 0 32px 0" }}
        // cover={<img alt={entry.person} src={entry.coverImage} />} // Placeholder image
        >
          <div className="_fv _fgap1 _backzoom0">
            <div className="_clickable"
              onClick={() => {
                navigate(`/@${alumniHandle}/${entry._id}`);
              }}
            />
            <div style={{ overflow: 'hidden' }}>
              <div
                className='_backzoom'
                style={{
                  height: '20em',
                  aspectRatio: '1/1',
                  backgroundImage: `url(${entry.coverImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: '0 0',
                  backgroundColor: '#2e2e2e',
                }}
              />
            </div>
            <div className="_fv _fgap08">
              {entry.name}
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};
